import '.b4{margin-top:0px;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import type { ReactNode } from 'react'
import { match } from 'ts-pattern'
import { typographyStyles, TypographyVariant } from './styles'

export type ParagraphProps = {
  children: ReactNode
  isBold?: boolean
  color?: string
  style?: Style
}

const BaseParagraph = ({
  children,
  style,
  isBold,
  color = 'var(--brand-secondary)',
  variant,
}: ParagraphProps & { variant: TypographyVariant }) => {
  const config = typographyStyles[variant]
  const fontWeight = isBold
    ? config.isBoldFontWeight || 500
    : config.fontWeight || 400

  return (
    <styled.p className="b4"
      style={{
        color,
        fontSize: config.fontSize,
        fontWeight,
        lineHeight: config.lineHeight,
        marginBottom: config.marginBottom || 0,
        ...style,
      }}
    >
      {children}
    </styled.p>
  )
}

const Large = (props: ParagraphProps) => (
  <BaseParagraph {...props} variant="large" />
)
const Medium = (props: ParagraphProps) => (
  <BaseParagraph {...props} variant="medium" />
)
const Small = (props: ParagraphProps) => (
  <BaseParagraph {...props} variant="small" />
)
const ExtraSmall = (props: ParagraphProps) => (
  <BaseParagraph {...props} variant="extraSmall" />
)
const Subtitle = (props: ParagraphProps) => (
  <BaseParagraph {...props} variant="subtitle" />
)

const ParagraphPropsBased = (
  props: ParagraphProps & {
    text: 'large' | 'medium' | 'small' | 'extraSmall'
  },
) => {
  return match(props.text)
    .with('large', () => Large(props))
    .with('medium', () => Medium(props))
    .with('small', () => Small(props))
    .with('extraSmall', () => ExtraSmall(props))
    .exhaustive()
}

const ParagraphRoot = ({ children }: { children: ReactNode }) => {
  return <>{children}</>
}

ParagraphRoot.Large = Large
ParagraphRoot.Medium = Medium
ParagraphRoot.Small = Small
ParagraphRoot.ExtraSmall = ExtraSmall
ParagraphRoot.Subtitle = Subtitle
ParagraphRoot.Sized = ParagraphPropsBased

export const Paragraph = ParagraphRoot
